export default __webpack_public_path__ + "static/media/flag-et.c2116427.svg";